import {AvdbCartItem} from "../../device-management/avdb-cart-item";
import {AvdbBundleCartItem} from "../../device-management/avdb-bundle-cart-item";
import {EnablementCartItem} from "../../device-management/enablement-cart-item";
import {GPCartItem} from "../../pilot-shared/gp-cart-item";
import {JSONMapped, jsonProperty} from "json-mapper-reflect";
import * as JSONMapper from "json-mapper";
import * as moment from "moment";

export class Cart extends JSONMapped() {
	@jsonProperty(JSONMapper.arrayOfClass(AvdbCartItem))
	avdbCart: Array<AvdbCartItem>;

	@jsonProperty(JSONMapper.arrayOfClass(AvdbBundleCartItem))
	avdbBundleCart: Array<AvdbBundleCartItem>;

	@jsonProperty(JSONMapper.arrayOfClass(EnablementCartItem))
	enablementCart: Array<EnablementCartItem>;

	@jsonProperty(JSONMapper.arrayOfClass(GPCartItem))
	gpCart: Array<GPCartItem>;

	@jsonProperty(JSONMapper.localTimestampFromISO)
	checkoutCompletedAt: moment.Moment;

	@jsonProperty(JSONMapper.localTimestampFromISO)
	fulfilledAt: moment.Moment;

	@jsonProperty(JSONMapper.localTimestampFromISO)
	yarmouthProcessedAt: moment.Moment;

	@jsonProperty()
	orderToken: string;

	@jsonProperty(JSONMapper.localTimestampFromISO)
	futureStartDate: moment.Moment;

	constructor(data?: Partial<Cart>) {
		super();
		Object.assign(this, data);
	}
}
